// extracted by mini-css-extract-plugin
module.exports = {"cameraFace":"TwoDOverlayCameraItem_cameraFace__3MGLI","nameHolder":"TwoDOverlayCameraItem_nameHolder__2CRQT","cameraFeedHolder":"TwoDOverlayCameraItem_cameraFeedHolder__2UBPn"};